import { enableProdMode } from "@angular/core";
import { launchModuleWithConfig } from "@jc2/config";
import { environment } from "./environments/environment";

if (environment.production) {
  enableProdMode();
}

const baseUrl =
  document?.head?.children[2]?.attributes?.getNamedItem("href")?.value;
(window as any).BASE_URL = `${baseUrl}`;
(window as any).ASSETS_URL = `${baseUrl}assets/`;

launchModuleWithConfig(environment.configFile, () =>
  import("./app/app.module").then((m) => m.AppModule),
);
